/**
 * Makes sure that an array does not exceed 1 MB
 */
export function monitorHistoryArraySize(jsonArray: any[]) {
  const jsonString = JSON.stringify(jsonArray, null, 2)
  const sizeInBytes = new Blob([jsonString]).size
  const sizeInMB = sizeInBytes / (1024 * 1024)
  if (sizeInMB > 1) {
    console.warn(
      "Warning: The size of the readHistory object exceeded 1 MB.",
    )
    console.warn(
      "The number of items in the array is now : ",
      jsonArray.length,
    )
    return
  }
}
